'use client';

import { usePathname } from 'next/navigation';
import { useAppSelector } from 'src/store/client/config';

import SectionHeader from '@/app/(football)/[team]/main/_components/Section/SectionHeader';

import CodeForm from './CodeForm';
import PersonalInfo from './PersonalInfo';
import RepresentativeCard from './RepresentativeCard';
import ShortCut from './ShortCut';

export default function HeroSection() {
  const pathname = usePathname();
  const { userInfo, LoggedIn: isLoggedIn } = useAppSelector((state) => state.user);

  const headerText = isLoggedIn && userInfo?.nick_name ? `${userInfo.nick_name}님, 환영해요` : '먼저 로그인해주세요';
  const headerLinkUrl = isLoggedIn ? '/mypage' : `/account/login?retUrl=${pathname}`;

  return (
    <section className="flex w-full flex-col items-center px-5 pt-6 pb-16">
      <SectionHeader linkUrl={headerLinkUrl} color="--color-g-90">{headerText}</SectionHeader>
      <PersonalInfo />
      <RepresentativeCard />
      <CodeForm />
      <ShortCut />
    </section>
  );
}
